import React from "react";
import Modal from "../../../../../components/Model_Power";
import GnaTgnaOptimalUtilisationAnylysis from "./Charts/GnaUtilisation";
import StateSummaryTiles from "../Generation/StateSummaryTiles";
import { getPowerExchangeAnalysisData } from "../../../../../Rest_api/RestApi";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

interface RowDetailPopupProps {
    isOpen: boolean;
    onClose: () => void;
    rowData: {
        seller?: string;
        entity?: string;
        name?: string;
        [key: string]: any;
    } | null;
    selectedExchanges?: string[];
    selectedMarkets?: string[];
}

export default function RowDetailPopup({
    isOpen,
    onClose,
    rowData,
    selectedExchanges,
    selectedMarkets,
}: RowDetailPopupProps) {
    const entityName = rowData?.seller || rowData?.entity || rowData?.name || "Entity";
    const selectedState = rowData?.name || "";

    const DefaultDates = useSelector((state: any) => state.defaultDatesSetter.defaultDates);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={<span className="text-base font-medium">{`${entityName} Analysis`}</span>}
            width="80%"
            maxWidth="95vw"
            height="auto"
            maxHeight="98vh"
            showCloseButton={true}
        >
            <StateSummaryTiles
                availableDates={DefaultDates?.["Power Market"]?.defaultTrendDates || []}
                selectedState={selectedState}
                selectedExchanges={selectedExchanges || []}
                selectedMarkets={selectedMarkets || []}
            />

            <GnaTgnaOptimalUtilisationAnylysis
                selectedBlock={rowData?.block}
                refreshKey={rowData?.refreshKey}
                selectedTargetDate={rowData?.selectedTargetDate}
                selectedState={selectedState}
                selectedExchanges={selectedExchanges}
                selectedMarkets={selectedMarkets}
            />
        </Modal>
    );
}
